const preprodCN = "w-full bg-surface-warning text-ink-warning p-2 text-center print:hidden";

const PreprodInfo = () => {
   return <div className={preprodCN}>Du er nå i test-miljøet.</div>;
};

export default PreprodInfo;
